import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { SHORTCUT_WIDGETS } from "@/config/dashboardWidgets";
import { useDashboardConfigStore } from "@/store/dashboardConfigStore";
import { cn } from "@/lib/utils";

export function QuickShortcuts() {
  const navigate = useNavigate();
  const { t } = useTranslation("adminui2");
  const { getVisibleWidgets } = useDashboardConfigStore();
  
  const visibleShortcuts = getVisibleWidgets()
    .filter(w => w.id.startsWith('shortcut-'))
    .map(w => SHORTCUT_WIDGETS.find(s => s.id === w.id))
    .filter(Boolean);

  if (visibleShortcuts.length === 0) return null;

  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2 sm:gap-3">
      {visibleShortcuts.map((shortcut) => {
        if (!shortcut) return null;
        const Icon = shortcut.icon;
        const isAction = shortcut.id.includes('new-');
        
        return (
          <Card 
            key={shortcut.id}
            className={cn(
              "cursor-pointer transition-all hover:shadow-md hover:scale-105",
              isAction && "border-dashed border-primary/50 bg-primary/5"
            )}
            onClick={() => shortcut.path && navigate(shortcut.path)}
          >
            <CardContent className="p-3 sm:p-4 flex flex-col items-center justify-center gap-2">
              <div className={cn(
                "p-2 rounded-lg",
                isAction ? "bg-primary/10 text-primary" : "bg-muted"
              )}>
                <Icon className="h-4 w-4 sm:h-5 sm:w-5" />
              </div>
              <span className="text-xs font-medium text-center line-clamp-1">
                {t(shortcut.nameKey)}
              </span>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
